import { Flex, Text } from '@mantine/core';
import { MyIcon } from '@web/common-ui';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';

export const MoneyValue = observer(
  ({
    money,
    isAvailable = false,
    darkMode = false,
  }: {
    money: number;
    isAvailable?: boolean;
    darkMode?: boolean;
  }) => {
    const { t } = useTranslation('homescreen');
    const color = darkMode ? '#6FB0F1' : '#1570CB';

    return (
      <Flex gap="4px" align="center">
        <MyIcon name="redeem" style={{ fill: color, height: 20 }} />
        <Text c={color} size="14px" lh="14px">
          {money}
        </Text>
        <Text c={color} size="14px" lh="14px">
          {t('currencyShort')} {isAvailable ? t('Open') : ''}
        </Text>
      </Flex>
    );
  },
);
